import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface EditDrawerState {
  isOpen: boolean;
  type: string; // "add" | "addSelected" | "edit+fieldID"
}

export interface AppState {
  width: number;
  height: number;
  isInEditMode: boolean;
  isEditDrawerOpen: EditDrawerState;
  isAiAssistantDrawerOpen: boolean;
}

const initialState: AppState = {
  width: window.innerWidth,
  height: window.innerHeight,
  isInEditMode: false,
  isEditDrawerOpen: { isOpen: false, type: "add" },
  isAiAssistantDrawerOpen: false,
};

const appSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setWidth: (state, action: PayloadAction<number>) => {
      const rootElement = document.getElementById("root");
      if (rootElement) {
        if (
          action.payload < 1440 &&
          !rootElement.classList.contains("dui-tablet-view")
        ) {
          document.getElementById("root")?.classList.add("dui-tablet-view");
        } else if (
          action.payload >= 1440 &&
          rootElement.classList.contains("dui-tablet-view")
        ) {
          document.getElementById("root")?.classList.remove("dui-tablet-view");
        }
      }
      state.width = action.payload;
    },
    setHeight: (state, action: PayloadAction<number>) => {
      state.height = action.payload;
    },
    setIsInEditMode: (state, action: PayloadAction<boolean>) => {
      state.isInEditMode = action.payload;
    },
    setIsEditDrawerOpen: (state, action: PayloadAction<EditDrawerState>) => {
      state.isEditDrawerOpen = action.payload;
    },
    setIsAiAssistantDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isAiAssistantDrawerOpen = action.payload;
    },
  },
});

export const {
  setWidth,
  setHeight,
  setIsInEditMode,
  setIsEditDrawerOpen,
  setIsAiAssistantDrawerOpen,
} = appSlice.actions;
export default appSlice.reducer;
